import { useState } from 'react';

export const Header = () => {
  const [open, setOpen] = useState(false);
  return <header className="header wrap">
    <a className="brand" href="#home" aria-label="Rudala home"><span className="brand-mark">r.</span>rudala<span className="brand-dot">®</span></a>
    <button className="menu-toggle" aria-label="Toggle navigation" aria-expanded={open} aria-controls="navigation" onClick={() => setOpen(!open)}>{open ? 'Close −' : 'Menu +'}</button>
    <nav id="navigation" className={open ? 'nav is-open' : 'nav'} aria-label="Main navigation">
      <a href="#services" onClick={() => setOpen(false)}>What we do</a><a href="#approach" onClick={() => setOpen(false)}>Our approach</a><a href="#about" onClick={() => setOpen(false)}>About us</a>
      <a className="button button-dark nav-cta" href="mailto:info.rudala@gmail.com">Let’s talk <span>↗</span></a>
    </nav>
  </header>;
};
